import { PropsWithChildren } from 'react';

import { JbNavigationWizardSectionGroupTitle } from '@bjb-gcrm/gcrm-frontend-components';
import { ZfStack } from '@zafire/react';

type Props = PropsWithChildren<{
  title: string;
}>;

export const NavigationSectionGroup = ({ title, children }: Props) => (
  <ZfStack>
    <JbNavigationWizardSectionGroupTitle title={title} />
    {children}
  </ZfStack>
);
